import React from "react";
import { useOutletContext } from "react-router-dom";

const TempProtection = () => {
  const { statusData } = useOutletContext();
  const E2 = statusData?.E2;

  return (
    <div className="overflow-x-auto mt-3 mb-5">
      <table className="table table-compact w-full">
        <thead className="text-white">
          <tr>
            <th className="bg-primary text-xs md:text-base">Project</th>
            <th className="bg-primary text-xs md:text-base">Machine</th>
            <th className="bg-primary text-xs md:text-base">Setting</th>
            <th className="bg-primary text-xs md:text-base">Action</th>
          </tr>
        </thead>
        <tbody>
          {/* row 1 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Temp Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.tempProtect} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 2 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Temp Recovery
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.tempRecovery} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 3 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Temp Difference Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.tempDiffProtect} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 4 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Battery Charging High Temp Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">{E2?.chargeOTP} °C</h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 5 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Battery Discharging High Temp Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.dischargeOTP} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 6 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Charge Low Temp Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">{E2?.chargeUTP} °C</h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 7 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Charge UTPR
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.chargeUTPR} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 8 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Discharge UTP
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.dischargeUTP} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 9 --------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Discharge Cryogenic Protection Recovery
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.dischargeUTPR} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 10 ------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Power Tube Temperature Protection
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.MOSOTP} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
          </tr>
          {/*------------------------------------------------------- */}

          {/* row 11 ------------------------------------------------*/}
          <tr>
            <td className="w-48 md:w-96">
              <h3 className="md:text-base font-medium whitespace-normal">
                Power Tube Temperature Recovery
              </h3>
            </td>
            <td>
              <h3 className="md:text-base font-medium">
                {E2?.MOSOTR} °C
              </h3>
            </td>
            <td className="w-48 md:w-64">
              <input
                type="number"
                placeholder="Type here"
                className="input input-xs md:input-sm input-bordered input-primary w-full mr-3"
              />
            </td>
            <td className="w-36">
              <button className="btn btn-primary btn-xs md:btn-sm w-36">
                Set
              </button>
            </td>
          </tr>
          {/*------------------------------------------------------- */}
        </tbody>
      </table>
    </div>
  );
};

export default TempProtection;
